import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateInventoryItemForm from "../../forms/CreateOrUpdateInventoryItemForm";
import { InventoryItemResponseDto } from "../../shared/dtos/inventoryItem/InventoryItemResponseDto";

interface UpdateInventoryItemModalProps {
  open: boolean;
  onClose: () => void;
  inventory: InventoryItemResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateInventoryItemModal: React.FC<UpdateInventoryItemModalProps> = ({
  open,
  onClose,
  inventory,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${inventory?.name || ""}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateInventoryItemForm
      isEditing={true}
      inventory={inventory}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateInventoryItemModal;
